import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  mt: '0',
  px: '2',
};
